module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_a01/btn_pc_4e7384d04be0e1cd945e1e77edd794ee.png";